module.exports = __webpack_public_path__ + "src/assets/img/newsaggregator.4b0e7a0c.jpg";